import { useEffect, useState } from 'react';

/** Phones, plus any window too short to hold the desktop chrome. */
export const COMPACT_MQ =
  '(max-width: 767.98px), (max-height: 540px)';

export function readCompactLayout() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(COMPACT_MQ).matches;
}

/**
 * True when the app should use the mobile shell (bottom nav, sheets, 44px targets).
 */
export function useCompactLayout() {
  const [compact, setCompact] = useState(readCompactLayout);

  useEffect(() => {
    const mq = window.matchMedia(COMPACT_MQ);
    const onChange = () => setCompact(mq.matches);
    onChange();
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('mdv-compact', compact);
    return () => root.classList.remove('mdv-compact');
  }, [compact]);

  return compact;
}
